export const RISK_INJURY_VALUES = [
  { value: 'NO_INJURY', label: 'No Injury' },
  { value: 'SLIGHT_REVERSIBLE_INJURY', label: 'Slight / Reversible Injury' },
  { value: 'SERIOUS_INJURY', label: 'Serious Injury' },
  { value: 'DEATH', label: 'Death' },
] as const

export const RISK_FREQUENCY_VALUES = [
  { value: 'RARELY', label: 'Rarely' },
  { value: 'OFTEN', label: 'Often' },
] as const

export const RISK_AVOIDANCE_VALUES = [
  { value: 'POSSIBLE', label: 'Possible' },
  { value: 'HARDLY_POSSIBLE', label: 'Hardly Possible' },
] as const

export const RISK_LIKELIHOOD_VALUES = [
  { value: 'LOW', label: 'Low' },
  { value: 'HIGH', label: 'High' },
] as const

export const RISK_SCORES = [
  { value: '0', label: '0', color: 'green' },
  { value: '1', label: '1', color: 'green' },
  { value: '2', label: '2', color: 'blue' },
  { value: '3', label: '3', color: 'yellow' },
  { value: '4', label: '4', color: 'yellow' },
  { value: '5', label: '5', color: 'orange' },
  { value: '6', label: '6', color: 'orange' },
  { value: '7', label: '7', color: 'red' },
  { value: '8', label: '8', color: 'red' },
  { value: '9', label: '9', color: 'red' },
  { value: '10', label: '10', color: 'red' },
] as const
